// @flow

import type { GlobalState, CustomFilters } from '../types';
import { getShortestDeliveryTime, hasVbmr } from '../../pdb';
import {
  getAssortmentCustomFilterDeliverytimeDuration,
  getAssortmentCustomFilterDeliverytime,
  getAssortmentCustomFilterVbmr,
} from '../../assortmentSettings';

export const FILTER_DELIVERY_DATE = 'delivery_date';
export const FILTER_DELIVERY_VBMR = 'delivery_VBMR';

export const getTranslation = (state: any) => (filterName: string) => {
  switch (filterName) {
    case FILTER_DELIVERY_DATE:
      return getAssortmentCustomFilterDeliverytime(state);
    case FILTER_DELIVERY_VBMR:
      return getAssortmentCustomFilterVbmr(state);
    default:
      return '';
  }
};

const applyCustomFilter = (
  state: GlobalState,
  pdbId: string,
  customFilters?: CustomFilters,
): boolean => {
  if (!customFilters || !Array.isArray(customFilters) || customFilters.length === 0) {
    return true;
  }

  return customFilters.every(filter => {
    if (filter === FILTER_DELIVERY_DATE) {
      return getShortestDeliveryTime(state, pdbId) <= parseInt(
        getAssortmentCustomFilterDeliverytimeDuration(state), 10,
      );
    }
    if (filter === FILTER_DELIVERY_VBMR) {
      return hasVbmr(state, pdbId);
    }
    return false;
  });
};

export default applyCustomFilter;
